import type { inicio as pt } from '../pt-BR/inicio';
import type { Traducao } from '../Traducao';

export const inicio = {
  saudacao: 'Hola, {{nome}}',
  responder: 'Responder',
  perfis: {
    profissional: 'Profesional',
    administrador: 'Administrador',
  },
} as const satisfies Traducao<typeof pt>;
